<template>
    <div class="row" id="mmy-row">
        <div class="row-wrapper flex w-full mt-0 justify-start align-center pl-[10px] pr-[10px]" :class="isAG26 && 'ag-row'">
            <vSelect class="mmy-input" :class="isAG26 && `ag-input ag-input${index}`" v-if="isAG26"
                :id="`asset_type_${index + 1}`"
                :placeholder="webstoreContent.cartPage.assetType"
                :options="assetTypes" label="displayName"
                :reduce="displayName => displayName.code"
                :value="row.assetType"
                @input="setRowAttribute($event, 'assetType')"
            >
                <span slot="no-options">
                    Loading...
                </span>
            </vSelect>

            <vSelect class="mmy-input" :class="isAG26 && `ag-input ag-input${index}`" v-if="isAG26 && diagnosticsCoverages.length > 0"
                :id="`diagnostics_coverage_${index + 1}`"
                :placeholder="webstoreContent.cartPage.diagnostics_coverage" 
                :options="diagnosticsCoverages" label="displayName" 
                :reduce="displayName => displayName.code" 
                :value="row.diagnosticsCoverage" 
                @input="setRowAttribute($event, 'diagnosticsCoverage')"
            ></vSelect>

            <vSelect class="mmy-input" :class="isAG26 && `ag-input ag-input${index}`" v-if="isAG26 && trailerTypes.length > 0"
                :id="`trailer_type_${index + 1}`"
                :placeholder="webstoreContent.cartPage.trailer_type"
                :options="trailerTypes" label="displayName"
                :reduce="displayName => displayName.code"
                :value="row.trailerType"
                @input="setRowAttribute($event, 'trailerType')"
            ></vSelect>

            <vSelect class="mmy-input" :class="isAG26 && `ag-input ag-input${index}` " v-if="isVGCableSelection || makes.length > 0"
                :id="`make_${index + 1}`"
                :placeholder="webstoreContent.cartPage.make"
                :options="makes"
                :value="row.make"
                @input="setRowAttribute($event, 'make')"
            >
                <span slot="no-options">
                    Loading...
                </span>
            </vSelect>

            <vSelect class="mmy-input" :class="isAG26 && `ag-input ag-input${index}`" v-if="isVGCableSelection || models.length > 0"
                :id="`model_${index + 1}`"
                :placeholder="webstoreContent.cartPage.model"
                :options="models"
                :value="row.model"
                @input="setRowAttribute($event, 'model')"
            >
                <span slot="no-options">
                    Please select a make
                </span>
            </vSelect>

            <vSelect class="mmy-input year" :class="isAG26 && `ag-input ag-input${index}`" v-if="isVGCableSelection || years.length > 0"
                :id="`year_${index + 1}`"
                :placeholder="webstoreContent.cartPage.year"
                :options="years"
                :value="row.year"
                @input="setRowAttribute($event, 'year')"
            >
                <span slot="no-options">
                    Loading...
                </span>
            </vSelect>

            <vSelect class="mmy-input" :class="isAG26 && `ag-input ag-input${index}`" v-if="isAG26 && diagnosticsPortTypes.length > 0"
                :id="`diagnostics_port_type_${index + 1}`"
                :placeholder="webstoreContent.cartPage.diagnostics_port_type"
                :options="diagnosticsPortTypes" label="displayName"
                :reduce="displayName => displayName.code"
                :value="row.diagnosticsPortType"
                @input="setRowAttribute($event, 'diagnosticsPortType')"
            ></vSelect>

            <div class="quantity-wrapper relative" :class="isAG26 && `ag-input-quantity ag-input-quantity${index}`">
                <input
                    class="mmy-quantity"
                    type="tel"
                    :id="`quantity_${index + 1}`"
                    :placeholder="webstoreContent.cartPage.quantity" 
                    v-model="displayedQuantity"
                >
                <svg @click="changeQuantity(true)" xmlns="http://www.w3.org/2000/svg" width="14" height="10" class="flipped">
                    <path
                        d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                    ></path>    
                </svg> 
                <svg @click="changeQuantity(false)" xmlns="http://www.w3.org/2000/svg" width="14" height="10">
                    <path
                        d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                    ></path>    
                </svg> 
            </div>

            <v-button
                class="w-1/12 button-wrap"
                :class="index === 0 && 'disabled'"
                position="left"
                mobile="12"
                tablet="12"
                desktop="12"
                styling="tertiary"
                :disabled="false"
                textAlign="left"
                @onClickEvent="showOptions = !showOptions">
                <template v-slot:content>
                    <div class="dot-wrapper">
                        <div class="dot" />
                        <div class="dot" />
                        <div class="dot last" />
                    </div>
                </template>
            </v-button>
        </div>
        <div v-if="showOptions" class="options-modal">
            <span class="underline" @click="removeRow">{{ webstoreContent.cartPage.delete }}</span>
        </div>
    </div>
</template>

<script>
    import vSelect from "vue-select";
    import "vue-select/src/scss/vue-select.scss";
    import {mapGetters} from 'vuex';
    import vButton from '../utils/button';
    import {getAGAttributeOptions, ag26KeysToDisplayValues} from '../../settings';
    import {titleCase, uncamelize} from '../../utils';

    export default {

        components: {vSelect, vButton},

        props: ['row', 'makesToModels', 'index', 'isCableAccessoriesPage'],

        data() {
            return {
                showOptions: false,
            }
        },

        computed: {
            ...mapGetters([
                'activeProductKey',
                'activeOfferKey',
                'displayVehicleCableSelectionOptions',
            ]),

            ...mapGetters('content', [
                'webstoreContent'
            ]),

            ...mapGetters('checkout', [
                'currencyIsoCode',
            ]),

            AGLength() {
                let length = 2 + (this.years.length > 0 ? 1 : 0) + (this.diagnosticsCoverages.length > 0 ? 1 : 0) + (this.trailerTypes.length > 0 ? 1 : 0) + (this.makes.length > 0 ? 1 : 0) + (this.models.length > 0 ? 1 : 0);
                Array.prototype.forEach.call(document.getElementsByClassName(`ag-input${this.index}`), (element) => {
                    element.style.width = `calc(78%/${length})`;
                });
                Array.prototype.forEach.call(document.getElementsByClassName(`ag-input-quantity${this.index}`), (element) => {
                    element.style.width = `calc(90%/${length})`;
                });
                return length;
            },

            isAG26() {
                return this.activeProductKey === 'AG26' || this.activeProductKey === 'AG-CBL';
            },

            isVGCableSelection() {
                return this.isAG26 ? false : this.displayVehicleCableSelectionOptions;
            },

            assetTypes() {
                return this.isAG26 ? this.createDisplayNameAndCode(getAGAttributeOptions(this.row, 'assetType')) : [];
            },

            trailerTypes() {
                return this.isAG26 ? this.createDisplayNameAndCode(getAGAttributeOptions(this.row, 'trailerType')) : [];
            },

            diagnosticsCoverages() {
                return this.isAG26 ? this.createDisplayNameAndCode(getAGAttributeOptions(this.row, 'diagnosticsCoverage')) : [];
            },

            makes() {
                return this.isAG26 ? getAGAttributeOptions(this.row, 'make') : Object.keys(this.makesToModels).sort();
            },

            models() {
                if (this.isAG26) {
                    return getAGAttributeOptions(this.row, 'model');
                } else {
                    return this.makesToModels.hasOwnProperty(this.row.make) ? this.makesToModels[this.row.make] : [];
                }
            },

            years() {
                return this.isAG26 ? getAGAttributeOptions(this.row, 'year').sort() :
                    [...Array(new Date().getFullYear() - 1995 + 1)].map((x, y) => (1996 + y).toString()).sort().reverse().concat(['1980-1995'])
            },

            diagnosticsPortTypes() {
                return this.isAG26 ? this.createDisplayNameAndCode(getAGAttributeOptions(this.row, 'diagnosticsPortType')) : [];
            },

            cablesNeededCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesNeededCount`];
            },

            totalCablesSubmittedCount() {
                let cableData = this.$store.getters[
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/totalCablesSubmittedData`
                ];
                let totalQuantity = 0;
                cableData && cableData.forEach(cable => {
                    totalQuantity += cable.quantity;
                });
                return totalQuantity;
            },

            displayedQuantity: {
                get() {
                    return this.row.quantity === 0 ? '' : this.row.quantity;
                },
                set(newQuantity) {
                    newQuantity = Math.abs(parseInt(newQuantity));
                    this.setRowAttribute(newQuantity, 'quantity');
                }
            },

            MMYType() {
                return this.displayVehicleCableSelectionOptions ? this.webstoreContent.selectProductsPage.vehicle : this.webstoreContent.selectProductsPage.asset_type;
            },
        },

        methods: {
            createDisplayNameAndCode(optionsList) {
                return optionsList.map(key => {
                    let displayName = key in ag26KeysToDisplayValues ? ag26KeysToDisplayValues[key] : titleCase(uncamelize(key));
                    return {displayName: displayName, code: key}
                });
            },

            changeQuantity(increment) {
                if (increment) {
                    // Can't increment above the needed amount
                    if (!(!this.isCableAccessoriesPage && (this.displayedQuantity === this.cablesNeededCount - this.totalCablesSubmittedCount))) {
                        this.setRowAttribute(this.displayedQuantity !== '' ? this.displayedQuantity + 1 : 1, 'quantity')
                    }
                } else {
                    this.setRowAttribute(this.displayedQuantity !== '' ? this.displayedQuantity - 1 : 0, 'quantity')
                }
            },

            clearAttribute(payload) {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/clearAttribute`, payload);
            },

            bulkClearAttribute(clearAttributeList) {
                for (let attribute of clearAttributeList) {
                    this.clearAttribute({index: this.index, attribute: attribute});
                }
            },

            removeRow() {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/removeRow`, this.index);
            },

            setRowAttribute(newValue, attribute) {
                this.$emit('has-changed');
                let payload = {index: this.index, attribute: attribute, value: newValue};
                this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/setRowAttribute`, payload);
                this.$nextTick(() => this.AGLength);
            },

            onQuantityChange(newQuantity) {
                if (newQuantity >= 0) {
                    this.setRowAttribute(newQuantity, 'quantity');
                } else {
                    this.setRowAttribute(0, 'quantity');
                }
            },
        },

         watch: {
            'row.assetType': {
                 handler(value) {
                    this.bulkClearAttribute(['trailerType', 'diagnosticsCoverage', 'make', 'model', 'year', 'diagnosticsPortType'])
                 },
             },
            'row.trailerType': {
                 handler(value) {
                    if (!value === '') {
                        this.bulkClearAttribute(['make', 'model', 'year', 'diagnosticsPortType'])
                    }
                 },
             },
            'row.diagnosticsCoverage': {
                 handler(value) {
                    if (!value === '') {
                        this.bulkClearAttribute(['make', 'model', 'year', 'diagnosticsPortType'])
                    }
                 },
             },
            'row.make': {
                 handler(value) {
                    if (!value === '') {
                        this.bulkClearAttribute(this.isAG26 ? ['model', 'year', 'diagnosticsPortType'] : ['model'])
                    }
                 },
             }
         },
    }
</script>

<style lang="scss" scoped>

    .underline {
        text-decoration: underline;
        margin-left: 8px;
    }

    .margin-0 {
        margin: 0px;
    }

    .full-width {
        width: 100%;
    }

    .flex {
        display: flex;
    }

    .flex-center {
        align-items: center;
        justify-content: center;
    }

    #mmy-row {
        width: 100%;
        margin-bottom: 15px;
        position: relative;
    }

    #mmy-row ::v-deep input[type="number"]::-webkit-inner-spin-button {
        opacity: 1;
        -webkit-appearance: textfield;
        -moz-appearance: textfield;
        appearance: textfield;
    } 

    .vehicle-input-title {
        font-size: 24px;
        margin: 24px 0px;
        padding: 0;
    }

    span {
        cursor: pointer;
    }

    ::v-deep {
        button {
            border: 1px solid #c1c9d1;
            border-radius: 5px;
            height: 48px;
            padding: 0 10px;
        }
        ::placeholder {
            color: #757575;
        }

        .mmy-input {
            width: fit-content;
            margin: 0px 0px;
            padding-left: 0px;
            margin-right: 20px;
            max-width: 400px;

            @media (max-width: 736px) {
                margin-right: 0;
                max-width: unset;
            }

            .vs__dropdown-toggle {
                border: 1px solid #c1c9d1;
                height: 52px;
                font-size: 18px;
                line-height: 24px;
                color: #00263E !important;
                padding-left: 5px;
                padding-right: 5px;
                overflow: hidden;
                width: 145px;
                padding-bottom: 0;
            }

            .vs__selected-options {
                overflow: hidden;
                max-width: 100%;
                height: 52px;
            }

            .vs__clear {
                display: none;
            }

            .vs__selected {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                height: 52px;
                padding-left: 0;
                margin: 0;
                width: 100px;
                display: inline-block;
                padding-top: 15px;
                color: #00263E;
            }

            .vs__dropdown-menu {
                width: 100%;
                min-width: 0px;
                padding-left: 0px 50px 0px 0px;
            }

            @media (min-width: 736px) {
                .vs__dropdown-menu {
                    width: 200%;
                }
            }
        }
        .year {
            .vs__dropdown-menu {
                width: 100% !important;
            }
        }
        .ag-input {
            width: 100%;
            max-width: 160px;
            .vs__dropdown-menu {
                width: 200% !important;
            }
            .vs__dropdown-toggle {
                width: 100%;
            }
        }
        .ag-input-quantity {
            width: 100%;
            max-width: 160px;
        }
    }

    .mmy-quantity {
        width: 121px;
        padding-left: 11px;
        height: 52px;
        border-radius: 4px;
        border: 1px solid #c1c9d1;
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 0 !important;
    }

    input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .quantity-wrapper input[type=number] {
        -moz-appearance: textfield;
        -webkit-appearance: none;
    }

    .vehicle-input {
        border: transparent;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-basis: 20%;
        position: relative;
    }

    .vehicle-input-dropdown, .quantity-input {
        margin-bottom: 0px;
    }

    .vehicle-input-dropdown {
        width: 100%;
        border: transparent;
    }

    #remove-mmy-row-button {
        color: white;
        height: 48px;
        background-color: #eb0045;
        border-radius: 4px;
        border: none;
        font-size: 20px;
        line-height: 20px;
        margin-top: 3%;
    }

    #remove-mmy-row-button:hover {
        cursor: pointer;
        background-color: #EB004C;
        border: #0d6ede;
    }

    #remove-mmy-row-x-icon {
        max-width: 8.2%; /* Fix spacing on Safari */
    }

    svg {
        position: relative;
        top: 0px;
        right: 0px;
    }

    @media only screen and (max-width: 735px) {
        .mmy-input {
            margin-top: 10px;
            padding-right: 0px;
            width: 100%;
        }

        .mmy-quantity {
            margin-top: 10px;
        }

        #remove-mmy-row-x-icon {
            display: none;
        }
    }

    .button-wrap {
        margin-left: 15px !important;
    }

    .ag-input {
       
    }

    .ag-input input {
        min-width: 100%;
    }

    .ag-input ::v-deep .vs__dropdown-toggle {
        min-width: 100%;
    }

    .ag-row {
        display: flex;
        flex-wrap: nowrap !important;
        height: auto;
        max-width: 100%;
    }

    .disabled {
        pointer-events: none;
    }

    .quantity-wrapper svg {
        position: absolute;
        right: 10px;
        top: 31px;
        opacity: .4;
        cursor: pointer;
    }

    .quantity-wrapper svg.flipped{
        position: absolute;
        right: 10px;
        top: 12px;
        transform: rotate(180deg);
    }

    .row-wrapper {
        flex-wrap: nowrap;
        height: fit-content;
        margin-top: 10px;
    }

    #container {
        margin: 0;
    }

    .dot-wrapper {
        width: 5px;
        height: fit-content;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .dot {
        width: 5px;
        height: 5px;
        margin-bottom: 3px;
        border-radius: 100%;
        background-color: #00263E;
    }

    .dot .last {
        margin-bottom: 0;
    }

    .disabled .dot {
        background-color: silver;
    }

    .disabled .dot-wrapper {
        cursor: not-allowed;
    }

    .options-modal {
        width: 90px;
        height: 40px;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        box-shadow: 0 2px 8px 1px lightgray;
        position: absolute;
        z-index: 10000;
        right: 30px;
        top: 5px;
    }

    .options-modal span {
        margin: 0;
    }

    @media (min-width: 736px) {
        .row-wrapper {
            padding: 0;
        }
        .ag-input ::v-deep .vs__selected {
            width: 550px !important;
        }

        .ag-input-quantity input {
            width: 100%;
        }
    }

    @media (max-width: 600px) {
        #mmy-input {
            width: 250px;
        }
        .row-wrapper {
            flex-wrap: wrap;
        }
        .quantity-wrapper {
            width: 70%;
            margin-top: 10px;
        }
        .mmy-quantity {
            margin: 0 auto;
            width: 100%;
        }
        .dot-wrapper {
            margin-top: 10px;
        }
    }

</style>
